import { DrawerBody, DrawerHeader } from '@chakra-ui/react'
import { mdiAlertCircleOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { useTranslation } from 'react-i18next'

import DrawerDialog from '@/components/drawer'
import { Box } from '@/components/ui/box'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'

import DrawerFooter from './components/drawerFooter'

const InvalidCharactersFileName = ({ isOpen, files, onClose }: { isOpen: boolean; files: File[]; onClose: () => void }) => {
    const { t } = useTranslation()
    const borderColor = useColorModeValue('gray.300', 'gray.700')

    return (
        <DrawerDialog isOpen={isOpen} onClose={onClose}>
            <DrawerHeader borderBottomWidth="1px" borderColor={borderColor} px="0" py="24px">
                <Box display="flex" alignItems="center">
                    <Icon path={mdiAlertCircleOutline} size="20px" color="var(--chakra-colors-status-error)" />
                    <Text ml="18px" fontSize="21px" fontWeight="bold" letterSpacing="0.25px" fontFamily="GSKPrecision-Bold">
                        {t('documents.invalidCharactersFileName.title')}
                    </Text>
                </Box>
            </DrawerHeader>
            <DrawerBody px="0" py="24px">
                <Text
                    fontSize="14px"
                    fontWeight="bold"
                    letterSpacing="0.25px"
                    fontFamily="GSKPrecision-Bold"
                    color={useColorModeValue('var(--chakra-colors-dark-700)', 'white')}
                    mb="24px"
                >
                    {t('documents.invalidCharactersFileName.description')}
                </Text>
                {files.map((item, index) => {
                    return (
                        <Text key={item.name + index} fontSize="14px" letterSpacing="0.25px" mt="16px">
                            {item.name}
                        </Text>
                    )
                })}
            </DrawerBody>
            <DrawerFooter onClose={onClose} />
        </DrawerDialog>
    )
}

export default InvalidCharactersFileName
